export default "__VITE_ASSET__CgAwj7X4__"